﻿import dotProp from 'dot-prop-immutable';

import {
    REDUCE_BROKER_COMPANY_QUERY_ELEMENT,
    REDUCE_BROKER_UPLOADS_HISTORY,
    REDUCE_BROKERCOMPANIES,
    REDUCE_BROKERCOMPANY,
    REDUCE_BROKERCOMPANY_ELEMENT,
    REDUCE_BROKERCOMPANY_FEE,
    REDUCE_BROKERCOMPANY_PRODUCT,
    REDUCE_DEFAULT_BROKER_GUID,
    REDUCE_ENTITY,
    REDUCE_FILE_UPLOADS_HISTORY,
    REDUCE_TEMPLATE_EDITOR_DRAFTS,
} from '../../constants/actions/brokerCompany';

const initialState = {
    entity: null,
    brokerCompany: null,
    query: {
        take: 25,
        skip: 0,
        orderByDesc: true,
    },
    brokerCompanies: [],
    fileUploadsHistory: [],
    brokerUploadsHistory: [],
    billingDashboard: null,
    smoBrokerDashboard: null,
    campaigns: [],
    templateEditorDrafts: null,
    smoDocumentPreview: null,
    defaultBrokerGuid: null,
};

function brokerCompanyReducer(state = initialState, action) {
    let elementIndex = 0;
    switch (action.type) {
        case REDUCE_ENTITY:
            return dotProp.set(state, 'entity', action.payload);
        case REDUCE_BROKERCOMPANY_ELEMENT: {
            let newState = state;
            if (!state.brokerCompany) {
                newState = dotProp.set(state, 'brokerCompany', {});
            }
            return dotProp.set(newState, `brokerCompany.${action.payload.code}`, action.payload.value);
        }
        case REDUCE_BROKERCOMPANY_FEE: {
            elementIndex = state.brokerCompany.brokerCompanyFees.findIndex(
                (ele) => ele.brokerCompanyFeeGuid === action.payload.value.brokerCompanyFeeGuid,
            );
            if (elementIndex >= 0) {
                return dotProp.set(state, `brokerCompany.brokerCompanyFees.${elementIndex}`, action.payload.value);
            }
            const lengthOfReference = state.brokerCompany.brokerCompanyFees?.length;
            return dotProp.set(
                state,
                `brokerCompany.brokerCompanyFees.${lengthOfReference ? lengthOfReference : 0}`,
                action.payload.value,
            );
        }
        case REDUCE_BROKERCOMPANY_PRODUCT: {
            elementIndex = state.brokerCompany.brokerCompanyProducts.findIndex(
                (ele) => ele.brokerCompanyProductGuid === action.payload.value.brokerCompanyProductGuid,
            );
            if (elementIndex >= 0) {
                return dotProp.set(state, `brokerCompany.brokerCompanyProducts.${elementIndex}`, action.payload.value);
            }
            const lengthOfReference = state.brokerCompany.brokerCompanyProducts?.length;
            return dotProp.set(
                state,
                `brokerCompany.brokerCompanyProducts.${lengthOfReference ? lengthOfReference : 0}`,
                action.payload.value,
            );
        }
        case REDUCE_BROKERCOMPANY:
            return {
                ...state,
                brokerCompany: {
                    ...state.brokerCompany,
                    ...action.payload,
                },
            };
        case REDUCE_BROKER_COMPANY_QUERY_ELEMENT:
            return dotProp.set(state, `query.${action.payload.code}`, action.payload.value);
        case REDUCE_BROKERCOMPANIES:
            return dotProp.set(state, 'brokerCompanies', action.payload);
        case REDUCE_FILE_UPLOADS_HISTORY:
            return dotProp.set(state, 'fileUploadsHistory', action.payload);
        case REDUCE_BROKER_UPLOADS_HISTORY:
            return dotProp.set(state, 'brokerUploadsHistory', action.payload);
        case 'REDUCE_BILLING_DASHBOARD':
            return dotProp.set(state, 'billingDashboard', action.payload);
        case 'REDUCE_SMO_BROKER_DASHBOARD':
            return dotProp.set(state, 'smoBrokerDashboard', action.payload);
        case 'REDUCE_SMO_DOCUMENT_PREVIEW':
            return dotProp.set(state, 'smoDocumentPreview', action.payload);
        case 'REDUCE_CAMPAIGNS':
            return dotProp.set(state, 'campaigns', action.payload);
        case REDUCE_TEMPLATE_EDITOR_DRAFTS:
            return dotProp.set(state, 'templateEditorDrafts', action.payload);
        case REDUCE_DEFAULT_BROKER_GUID:
            return dotProp.set(state, 'defaultBrokerGuid', action.payload);
        default:
            return state;
    }
}

export default brokerCompanyReducer;
